export const getters = {
    activeBasemap: (state) => {
        return state.basemaps.find((layer) => layer.getVisible());
    },
    canBeTimeEnabled(state) {
        return false;
    },
    hasActiveMapInstance(state) {
        return state.ol.map !== undefined;
    },
    layerHasData(state) {
        return state.layer?.getSourceState();
    },
};
